export default __webpack_public_path__ + "static/media/DreamJobs2_13.2cb0bfce.png";